<template>
<div>
  <div class="main-content">
    <div class="content">
      <div class="nest-contents">
        <p id="err_message" class="err-message">{{ error }}</p>
        <div id="login-description">
          <div>入力されたメールアドレスへ認証メールが送信されます。</div>
        </div>
        <div class="get-start-pre-form pure-form">
          <form id="form" @submit="sendMail">
            <div class="fieldset">
              <label for="email">メールアドレス*</label>
              <input type="email" id="email-input" placeholder="example@norimemo.com" name="email" v-model="email" required>
              <span class="pure-form-message err-message" id="email-input-error">{{ emailError }}</span>
            </div>
            <button id="sign_in" class="pure-button pure-button-primary">送信</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      actionCodeSettings: {
        url: window.location.protocol + '//' + window.location.host + '/sign_in',
        // This must be true.
        handleCodeInApp: true
      },
      error: "",
      emailError: ""
    }
  },

  methods: {
    sendMail(e) {
      let params = new URLSearchParams()
      params.append('email', this.email)

      this.$http.post('comfirmation_email/sign_in', params).then(() => {
        this.$firebase.auth().sendSignInLinkToEmail(this.email, this.actionCodeSettings)
          .then(() => {
            this.$store.dispatch("setEmail", this.email)
            this.$router.push({ name: "sent_email", params: { type: "sign_in" } })
          })
          .catch(() => {
            this.error = "エラーが発生しました。"
          })
      }).catch((err) => {
        if (err.response.data.email) {
          this.emailError = err.response.data.email
        } else {
          this.error = "エラーが発生しました。"
        }
      })

      e.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
#login-description {
  width: fit-content;
  margin: auto;
  margin-bottom: 15px;
  text-align: initial;
}

.pure-button-primary{
  background: linear-gradient(180deg, #fff5ee, #83ccd2);
  color: black;
}
</style>